import up from './arrow-up.svg';
import right from './arrow-right.svg';
import down from './arrow-down.svg';
import left from './arrow-left.svg';

export const arrowsDir = {
    up,
    right,
    down,
    left
};